import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-maintenance',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent {}
